import React from "react";
import usePageMetadata from "../hooks/usePageMetadata";

const sectionTitle = "text-2xl font-semibold text-[#0A192F] mt-8 mb-4";
const paragraph = "text-[#0A192F]/80 leading-relaxed mb-4";

const PrivacyPolicy = () => {
  usePageMetadata({
    title: "TOLSOL | Pol\u00edtica de privacidad",
    description:
      "Consulta la pol\u00edtica de privacidad de TOLSOL y conoce c\u00f3mo protegemos tus datos personales.",
  });

  return (
    <main className="bg-[#F2F2F2] pt-32 pb-16 text-[#0A192F]">
      <div className="container mx-auto px-4 max-w-4xl">
        <header className="mb-10">
          <h1 className="text-4xl font-bold mb-4">Pol\u00edtica de privacidad</h1>
          <p className="text-[#0A192F]/70">
            En TOLSOL tratamos tus datos personales con total responsabilidad. A continuaci\u00f3n encontrar\u00e1s
            la informaci\u00f3n detallada sobre c\u00f3mo lo hacemos.
          </p>
        </header>

        <section>
          <h2 className={sectionTitle}>Finalidades del tratamiento</h2>
          <p className={paragraph}>
            Tratamos los datos personales que nuestros clientes y usuarios nos facilitan a trav\u00e9s de los
            formularios habilitados tanto en nuestra p\u00e1gina web como en soporte f\u00edsico, con la finalidad de
            resolver sus consultas, gestionar las ventas y mantener informados a nuestros suscriptores acerca de las
            novedades disponibles en nuestro establecimiento. Si solo eres usuario de nuestra web, los \u00fanicos datos
            personales que tratamos son los derivados del uso de cookies y aquellos que voluntariamente nos hagas
            llegar a trav\u00e9s de los medios de contacto disponibles.
          </p>
          <p className={paragraph}>
            Podemos enviarte informaci\u00f3n peri\u00f3dica sobre novedades relacionadas con nuestra actividad
            comercial si previamente nos has dado tu consentimiento. Podr\u00e1s dejar de recibir estas comunicaciones
            en cualquier momento indic\u00e1ndolo a trav\u00e9s de los canales habilitados.
          </p>
          <p className={paragraph}>
            Si nos facilitas tu curr\u00edculum vitae porque deseas trabajar con nosotros, tus datos se tratar\u00e1n
            con la \u00fanica finalidad de gestionar nuestra bolsa de empleo y los procesos de selecci\u00f3n de
            personal.
          </p>
        </section>

        <section>
          <h2 className={sectionTitle}>Legitimaci\u00f3n del tratamiento</h2>
          <p className={paragraph}>
            Para atender tus consultas y gestionar las ventas nos amparamos en la ejecuci\u00f3n del contrato y en la
            aplicaci\u00f3n de medidas precontractuales (art. 6.1b RGPD). Para el env\u00edo de informaci\u00f3n
            comercial, la base legal es tu consentimiento expreso (art. 6.1a RGPD). En el caso de los datos curriculares
            tratados para la gesti\u00f3n de nuestra bolsa de empleo tambi\u00e9n nos basamos en tu consentimiento. Estas
            legitimaciones se complementan con el cumplimiento de las obligaciones legales que correspondan.
          </p>
        </section>

        <section>
          <h2 className={sectionTitle}>Destinatarios de la informaci\u00f3n</h2>
          <p className={paragraph}>
            Los datos personales podr\u00e1n ser tratados por nuestros encargados de tratamiento, quienes est\u00e1n
            obligados a cumplir con la legislaci\u00f3n vigente en materia de protecci\u00f3n de datos y a seguir
            nuestras instrucciones. No podr\u00e1n utilizar los datos con una finalidad diferente a la descrita. No
            realizamos transferencias internacionales de datos.
          </p>
        </section>

        <section>
          <h2 className={sectionTitle}>Plazos de conservaci\u00f3n</h2>
          <p className={paragraph}>
            - Gesti\u00f3n de servicios: conservaremos tus datos durante cuatro a\u00f1os desde la finalizaci\u00f3n de la
            relaci\u00f3n comercial.<br />
            - Finalidad comercial: conservaremos tus datos mientras mantengas activa tu suscripci\u00f3n a nuestras
            comunicaciones. Una vez manifestada tu negativa a recibirlas, los eliminaremos salvo que debamos seguir
            conserv\u00e1ndolos por obligaciones legales, en cuyo caso quedar\u00e1n debidamente bloqueados.
          </p>
        </section>

        <section>
          <h2 className={sectionTitle}>Derechos</h2>
          <p className={paragraph}>
            Puedes ejercer gratuitamente los derechos de acceso, rectificaci\u00f3n, supresi\u00f3n, oposici\u00f3n,
            limitaci\u00f3n del tratamiento, portabilidad y a no ser objeto de decisiones automatizadas cuando proceda.
            Para ello puedes utilizar las siguientes v\u00edas:
          </p>
          <ul className="list-disc pl-6 text-[#0A192F]/80 space-y-3 mb-6">
            <li>
              Por escrito, acompa\u00f1ando copia de un documento acreditativo de tu identidad, en la direcci\u00f3n:
              TOLSOL - Atenci\u00f3n de Datos Personales, Calle Libertad 29, 28936 M\u00f3stoles (Madrid).
            </li>
            <li>
              Por correo electr\u00f3nico a{" "}
              <a href="mailto:info@tolsol.es" className="text-[#134b8a] underline">
                info@tolsol.es
              </a>{" "}
              firmando digitalmente tu solicitud con DNI electr\u00f3nico o adjuntando copia del DNI.
            </li>
          </ul>
        </section>

        <section>
          <h2 className={sectionTitle}>Autoridad de control</h2>
          <p className={paragraph}>
            Si consideras que tus derechos no han sido atendidos, puedes presentar una reclamaci\u00f3n ante la Agencia
            Espa\u00f1ola de Protecci\u00f3n de Datos o ante cualquier autoridad de control competente dentro de la
            Uni\u00f3n Europea.
          </p>
        </section>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
